


























































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'

import {
  checkUserBindWx,
  getUserInfoByUserId,
  applyDraw,
  getBindInfo
} from '@/api'
import { Toast } from 'vant'
import {
  appFunc_callLogin_wechat,
  appFunc_RegisterLoginCb,
  appFunc_RegisterLoginCbAli,
  appFunc_callLogin_ali,
  appFunc_senToken
} from '@/utils/bridge'
@Component({
  name: 'exchange-confirm',
  components: {}
})
export default class ExchangeConfirm extends Vue {
  presenTlist: any = {}

  //是否绑定微信
  bindWx = 0
  //头像
  headUrl = ''
  selectIndex = 1
  // 微信昵称
  wxNickName = ''

  loading = false
  showIosToast = false
  showUpdate = false

  bindData: any = {}
  async created() {
    // 检测是否绑定微信
    await this.getToken()
    this.checkUserBindWx()
    appFunc_callLogin_ali(this.bindSuccess)
    // 获取用户信息
    this.getUserInfoByUserId()

    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)
    console.log('阖家安康华东科技哈健身卡后', this.$route.query)
    const list: any = this.$route.query.list
    this.presenTlist = JSON.parse(list)
  }
  // 获取用户信息
  async getUserInfoByUserId() {
    const { data, code } = await getUserInfoByUserId({
      userId: CommonModule.userId
    })
    if (code == 1001) {
      const { headUrl, wxNickName, wxHeadUrl } = data
      this.headUrl = wxHeadUrl || headUrl
      this.wxNickName = wxNickName
    }
  }
  async getToken() {
    const res = await appFunc_senToken()
    console.log(res, '/////////////')
    CommonModule.setUserId(res.id)
    CommonModule.setToken(res.tokenForJs)
    CommonModule.setUserPhone(res.mobile)
    CommonModule.setUserName(res.name)
  }
  async checkUserBindWx() {
    const Authorization =
      CommonModule.token || '0f7d79b9d9a532059efea9105575c405'
    const result = await getBindInfo({
      Authorization: Authorization
    })
    console.log('绑定信息', result)
    if (result.code == 1001) {
      this.bindData = result.data
    } else {
      Toast(result.message)
    }
    // const { data, code, message } = await checkUserBindWx()
    // if (code == 1001) {
    //   this.bindWx = data
    // } else if (code == 10606) {
    //   Toast(message)
    // }
  }

  // 确认兑换
  async handelExchange() {
    this.loading = true
    // 提现-确认兑换
    const { aplus_queue }: any = window
    aplus_queue.push({
      action: 'aplus.record',
      arguments: ['click_to_bind_withdrawal', 'CLK']
    })
    let code = 0
    let message = CommonModule.DefaultToast
    try {
      const resData = await applyDraw({
        exchangeId: this.presenTlist.id,
        payType: this.selectIndex
      })
      code = resData.code
      message = resData.message
    } catch (error) {
      Toast(CommonModule.DefaultToast)
    }
    if (code == 1001) {
      Toast(this.$t('兑换提交成功，在清单中可查看积分兑换到账情况'))
      this.$router.push({
        path: '/exchange',
        query: {
          language: this.language
        }
      })
      this.loading = false
    } else if (code == 10601) {
      this.loading = false
      const { aplus_queue }: any = window
      aplus_queue.push({
        action: 'aplus.record',
        arguments: ['prompt_repeated_withdrawal', 'CLK']
      })
      Toast({
        message: message,
        duration: 8000
      })
    } else if (code == 10609) {
      this.showIosToast = true
    } else {
      this.loading = false
      Toast({
        message: message
      })
    }
  }
  get isIos() {
    if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
      return true
    }
    return false
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }
  updateUrl() {
    window.location.href = 'http://web.allosoft.top/h5/main/#/download-allo'
  }
  // 绑定微信
  handelBinding() {
    // 提现-点击绑定
    const { aplus_queue }: any = window
    aplus_queue.push({
      action: 'aplus.record',
      arguments: ['click_to_bind_withdrawal', 'CLK']
    })
    // 微信授权回调
    appFunc_RegisterLoginCb(this.handleSucceed)
    // 登录微信
    appFunc_callLogin_wechat()
  }

  handelBindingAli() {
    // 提现-点击绑定
    const { aplus_queue }: any = window
    aplus_queue.push({
      action: 'aplus.record',
      arguments: ['click_to_bind_withdrawal', 'CLK']
    })
    // const appVersion = CommonModule.appVersion
    // 是否实名认证
    // if (appVersion < '3.5') {
    //   this.showUpdate = true
    //   return
    // }
    // 支付宝授权回调
    // 登录微信
    appFunc_RegisterLoginCbAli()
  }
  bindSuccess(result: any) {
    if (result == 1001) {
      this.checkUserBindWx()
      this.getUserInfoByUserId()
      // 成功绑定
      const { aplus_queue }: any = window
      aplus_queue.push({
        action: 'aplus.record',
        arguments: ['successfully_bound_to_alipay', 'CLK']
      })
    } else {
      // Toast(CommonModule.DefaultToast)
    }
  }
  // 微信登录回调
  handleSucceed(data: any) {
    const { tokenForJs } = JSON.parse(data)
    CommonModule.setToken(tokenForJs)
    this.checkUserBindWx()
    this.getUserInfoByUserId()
    // 成功绑定
    const { aplus_queue }: any = window
    aplus_queue.push({
      action: 'aplus.record',
      arguments: ['successfully_bound_to_wechat', 'CLK']
    })
  }

  // 返回
  handelBack() {
    this.$router.back()
  }
}
